const ProductModal = ({ product, onClose, onAddToCart }) => {
  const handleAddToCart = () => {
    onAddToCart(product);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-5xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-2xl font-bold text-gray-900">
              {product.prod_name}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-xl"
            >
              ✕
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <img
              src={`../myNewAPI/${product.prod_img}`}
              alt={product.prod_name}
              className="w-full rounded-lg"
            />
            <div>
              <p className="text-gray-600 mb-4">{product.prod_descrp}</p>
              <p className="text-3xl font-bold text-gray-900 mb-4">
                PKR{" "}
                {product.prod_price
                  ? new Intl.NumberFormat("en-IN").format(product.prod_price)
                  : 0}
              </p>
              <button
                onClick={handleAddToCart}
                className="w-full bg-red-600 text-white py-3 px-4 rounded-md hover:bg-red-700 transition duration-200 font-semibold"
              >
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;
